import React from 'react';
import cx from 'classnames';

import type { IconProps } from './Icon.types';
import styles from './Icon.module.scss';
import { useDynamicSVGImport } from './useDynamicSVGImport';

const sizeMap = {
  'Small': 'small',
  'Medium': 'medium',
  'Large': 'large',
};

const Icon = (props: IconProps) => {
  const {
    className,
    style = 'Filled',
    size = 'Medium',
    icon,
  } = props;
  const { svgContent, error, loading } = useDynamicSVGImport(`${icon}${style}`);

  if (error) {
    return <div className={cx(styles.icon, styles[sizeMap[size]], className)} />;
  }

  if (loading) {
    return <div className={cx(styles.icon, styles[sizeMap[size]], className)} />;
  }

  if (svgContent) {
    return (
      <div className={cx(styles.icon, styles[sizeMap[size]], className)}>
        <div className={styles.svg} dangerouslySetInnerHTML={{ __html: svgContent }}/>
      </div>
    );
  }

  return null;
};

export default Icon;